import { Asset } from 'types/stellar';

export enum TokenType {
    classic = 'classic',
    soroban = 'soroban',
}

export type ClassicToken = Asset & {
    type: TokenType.classic;
    contract: string;
    decimal: number;
};

export type SorobanToken = {
    type: TokenType.soroban;
    contract: string;
    name: string;
    code: string;
    decimal: number;
    home_domain?: string;
    logo?: string;
    description?: string;
    asset_name?: string;
};

export type Token = ClassicToken | SorobanToken;
